export const XRAY_PANEL_STORAGE_KEY = 'charting:isXrayPanelOpen'

export const readXrayPanelInitial = (): boolean => {
  try {
    if (typeof window === 'undefined') return false
    const raw = window.sessionStorage.getItem(XRAY_PANEL_STORAGE_KEY)
    return raw === '1'
  } catch {
    return false
  }
}

export const persistXrayPanel = (open: boolean): void => {
  try {
    if (typeof window === 'undefined') return
    window.sessionStorage.setItem(XRAY_PANEL_STORAGE_KEY, open ? '1' : '0')
  } catch {
    /* sessionStorage unavailable (private mode, quota, etc.) — ignore */
  }
}
